export const quote_costs_locale = {
  QUOTE_COST: "Cost",
  QUOTE_COSTS: "Costs",
  ADD: "Add cost",
  DETAILS: "Cost details",
  ACTIVITY_CODE: "Activity code",
  CURRENCY: "Currency",
  NAME: "Name",
  PARTY_NAME: "Party name",
  QUANTITY: "Quantity",
  PRICE: "Price",
  TOTAL: "Total",
  TOTAL_EXCL_VAT: "Total excl. VAT",
  UOM: "Unit of measurement",
  TOTAL_EURO: "Total (€)",
  PARTY: "Party",
  NO_OTHER_SUPPLIERS_WITH_SAME_TARIFF_WERE_FOUND: "No other suppliers have tariffs that can be applied for this selection.",
  WE_FOUND_OTHER_SUPPLIERS_WITH_SAME_TARIFF: "We have found other suppliers having tariffs that can be applied for this selection, do you want to continue?",
  COMPANIES_SUGGESTIONS: "Existing companies with suitable tariffs",
  CURRENTLY_SELECTED_COMPANY: "Currently selected company",
  REVENUE_PRICE: "Revenue price",
  COST_PRICE: "Cost price",
  NO_TARIFF: "no tarrif",
  MODAL: {
    COSTS_CHANGED: "Cost lines have been changed in the meantime and need to be reloaded",
    TITLE_COSTS_CHANGED: "Cost lines have been changed",
    RELOAD_COSTS: "Reload costs"
  }
};
